export function createStepProgress(container, options = {}) {
const { translate = true } = options;
const stepItems = container.querySelectorAll('.step-item');
const stepsContainer = container.querySelector('.steps-container');
let previousIndex = 0;
let currentIndex = 0;

const updateStepProgress = (activeIndex) => {
    const isMovingForward = activeIndex > previousIndex;
    const totalSteps = stepItems.length;
    const isLastSlide = activeIndex === totalSteps - 1;

    if (stepsContainer && translate) {
        stepsContainer.style.transition = 'transform 600ms ease-in-out';
        
        const containerWidth = stepsContainer.parentElement.offsetWidth;
        const activeItem = stepItems[activeIndex];
        const itemLeft = activeItem.offsetLeft;
        const itemWidth = activeItem.offsetWidth;
        const itemCenter = itemLeft + (itemWidth / 2);
        const containerCenter = containerWidth / 2;

        let translateX = containerCenter - itemCenter;

        const maxTranslate = 0;
        const minTranslate = containerWidth - stepsContainer.scrollWidth;
        translateX = Math.max(minTranslate, Math.min(maxTranslate, translateX));

        stepsContainer.style.transform = `translateX(${translateX}px)`;
    }

        stepItems.forEach((item, index) => {
            const animatedLine = item.querySelectorAll('.step-line')[1];

            if (index === totalSteps - 1) {
                const lastStepProgressBar = item.querySelector('.step-end-progress');
                if (lastStepProgressBar && isLastSlide) {
                    setTimeout(() => {
                        lastStepProgressBar.classList.add('w-1/2');
                    }, 300);
                } else if (lastStepProgressBar) {
                    lastStepProgressBar.classList.remove('w-1/2');
                }
            }

            if (index < activeIndex) {
                item.classList.remove('step-active', 'step-inactive');
                item.classList.add('step-completed');
                if (animatedLine) {
                    animatedLine.classList.add('w-full');
                }
            } else if (index === activeIndex) {
                item.classList.remove('step-inactive');
                if (animatedLine) {
                    animatedLine.classList.add('w-full');
                }

                if (!isMovingForward || index === 0) {
                    item.classList.remove('step-completed');
                    item.classList.add('step-active');
                } else {
                    item.classList.remove('step-completed');
                    setTimeout(() => {
                        item.classList.add('step-active');
                    }, 300);
                }
            } else {
                item.classList.remove('step-completed', 'step-active');
                item.classList.add('step-inactive');
                if (animatedLine) {
                    animatedLine.classList.remove('w-full');
                }
            }
        });

        previousIndex = activeIndex;
        currentIndex = activeIndex;
    };

    const reset = () => {
        stepItems.forEach((item) => {
            item.classList.remove('step-active', 'step-completed', 'step-inactive');
            const animatedLine = item.querySelectorAll('.step-line')[1];
            if (animatedLine) {
                animatedLine.classList.remove('w-full');
            }
            const lastStepProgressBar = item.querySelector('.step-end-progress');
            if (lastStepProgressBar) {
                lastStepProgressBar.classList.remove('w-1/2');
            }
        });
        previousIndex = 0;
        currentIndex = 0;
    };

    const goTo = (index) => {
        if (index >= 0 && index < stepItems.length) {
            updateStepProgress(index);
        }
    };

    const prev = () => {
        if (currentIndex > 0) {
            goTo(currentIndex - 1);
        }
    };

    const next = () => {
        if (currentIndex < stepItems.length - 1) {
            goTo(currentIndex + 1);
        }
    };

    return { stepItems, updateStepProgress, reset, goTo, prev, next, get currentIndex() { return currentIndex; }, get totalSteps() { return stepItems.length; } };
}
